import React from 'react';
import { FlightButton } from '@flybits/design-system';

import EmptyAuditHistory from 'assets/images/audit-history-empty.svg';
import NoResultsFoundSvg from 'assets/images/no-results-found.svg';

interface AuditEmptyStateProps {
  type: 'no-history' | 'no-results';
  onCreateExperience: () => void;
}

const AuditEmptyState: React.FC<AuditEmptyStateProps> = ({ type, onCreateExperience }) => {
  const isNoHistory = type === 'no-history';

  return (
    <div className="audit__content__empty">
      <div className="audit__content__empty__image">
        <img
          src={isNoHistory ? EmptyAuditHistory : NoResultsFoundSvg}
          alt={isNoHistory ? 'Empty audit history illustration' : 'No search results illustration'}
        />
      </div>
      <span className="audit__content__empty__text audit__content__empty__text--main">
        {isNoHistory ? 'Looks like there is no audit history here' : 'No results found'}
      </span>
      <span className="audit__content__empty__text audit__content__empty__text--sub">
        {isNoHistory
          ? "Audit history shows the users' activities within your organization. This feature records the occurrence of an event, the time at which it occurred, the responsible user, and the impacted entity."
          : 'Try adjusting search or filter to find what you are looking for.'}
      </span>
      {isNoHistory && (
        <>
          <span className="audit__content__empty__text audit__content__empty__text--explanation">
            How about start creating a new experience?
          </span>
          <span>
            <FlightButton
              className="audit__content__empty__create-experience-button"
              label="Create an experience"
              size="large"
              onClick={onCreateExperience}
            />
          </span>
        </>
      )}
    </div>
  );
};

export default AuditEmptyState;
